// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper[data-v-1d6a6828]{height:auto;overflow:hidden;padding-bottom:4rem;position:relative;width:100%}.swiper-slide[data-v-1d6a6828]{align-items:center;display:flex;justify-content:center}.slider-content[data-v-1d6a6828]{color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
